import {
  limitReducer,
  limitInitialState,
  pageReducer,
  pageInitialState,
  projectModalReducer,
  projectsReducer,
  projectsInitialState,
  TProjectsState,
  alertReducer,
} from 'shared/slices/admin';
import { combineReducers } from '@reduxjs/toolkit';

export type TPreloadedProjectsListState = {
  projects: TProjectsState;
  page: number;
  limit: number;
};

export const projectsListPreloadedState: TPreloadedProjectsListState = {
  projects: projectsInitialState,
  page: pageInitialState,
  limit: limitInitialState,
};

export const projectsListReducer = combineReducers({
  projects: projectsReducer,
  projectModal: projectModalReducer,
  page: pageReducer,
  alert: alertReducer,
  limit: limitReducer,
});

export type TProjectsListState = ReturnType<typeof projectsListReducer>;
